import React from "react";

const PayperviewCountdown = () => {
  return (
    <div className="w-[90%] max-sm:w-full max-lg:w-[90%] mb-5 overflow-hidden rounded-2xl border border-white/15 bg-black/40 px-5 py-4 backdrop-blur-md">
      <div className="mx-auto mb-3 h-4 w-32 animate-pulse bg-[#1a1919]"></div>
      <hr className="mx-auto my-3 w-full opacity-[30%]" />
      <div className="flex items-center justify-between">
        <div className="text-center">
          <div className="w-[50px] h-[10px] bg-[#1a1919] animate-pulse"></div>
          <div className="w-[50px] mt-2 h-[40px] bg-[#1a1919] animate-pulse"></div>
        </div>
        <div className="text-center">
          <div className="w-[50px] h-[10px] bg-[#1a1919] animate-pulse"></div>
          <div className="w-[50px] mt-2 h-[40px] bg-[#1a1919] animate-pulse"></div>
        </div>
        <div className="text-center">
          <div className="w-[50px] h-[10px] bg-[#1a1919] animate-pulse"></div>
          <div className="w-[50px] mt-2 h-[40px] bg-[#1a1919] animate-pulse"></div>
        </div>
        <div className="text-center">
          <div className="w-[50px] h-[10px] bg-[#1a1919] animate-pulse"></div>
          <div className="w-[50px] mt-2 h-[40px] bg-[#1a1919] animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default PayperviewCountdown;
